/* ─────────────────────────────────────────────
   Loop Lab — Site search
   Header icon opens a predictive-search panel. Typing queries Shopify's
   /search/suggest.json; Enter (or "View all") goes to the /search page.
   Self-contained: does not modify or depend on theme.js internals beyond
   the optional LoopCart.formatMoney helper.
   ───────────────────────────────────────────── */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var LIMIT = 6;

  function init() {
    var openBtn = document.getElementById('search-toggle');
    var panel = document.getElementById('search-panel');
    var overlay = document.getElementById('search-overlay');
    var closeBtn = document.getElementById('search-close');
    var form = document.getElementById('search-form');
    var input = document.getElementById('search-input');
    var clearBtn = document.getElementById('search-clear');
    var results = document.getElementById('search-results');

    if (!openBtn || !panel || !input || !results) return;

    var timer = null;
    var controller = null;
    var lastQuery = '';
    var activeIndex = -1;

    function money(cents) {
      var n = Number(cents);
      if (isNaN(n)) return '';
      if (typeof LoopCart !== 'undefined' && LoopCart.formatMoney) return LoopCart.formatMoney(n);
      return '₹' + Math.round(n / 100);
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function open() {
      panel.classList.add('open');
      overlay.classList.add('visible');
      panel.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 80);
    }

    function close() {
      panel.classList.remove('open');
      overlay.classList.remove('visible');
      panel.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('open')) close();
    });

    clearBtn && clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      renderIdle();
      input.focus();
    });

    /* Enter submits to the full results page. */
    form && form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      var active = results.querySelector('.search-result.is-active');
      if (active && active.href) {
        e.preventDefault();
        window.location.href = active.href;
      }
      /* otherwise let the form submit natively to /search?q=... */
    });

    input.addEventListener('input', function () {
      clearBtn && (clearBtn.hidden = !input.value);
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { renderIdle(); return; }
      timer = setTimeout(function () { search(q); }, DEBOUNCE_MS);
    });

    /* Arrow-key navigation through the suggestions. */
    input.addEventListener('keydown', function (e) {
      var items = results.querySelectorAll('.search-result');
      if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex += (e.key === 'ArrowDown' ? 1 : -1);
        if (activeIndex < 0) activeIndex = items.length - 1;
        if (activeIndex >= items.length) activeIndex = 0;
        for (var i = 0; i < items.length; i++) {
          items[i].classList.toggle('is-active', i === activeIndex);
        }
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      }
    });

    function renderIdle() {
      activeIndex = -1;
      results.innerHTML = '<p class="search-status">Start typing to search products.</p>';
    }

    function renderEmpty(q) {
      activeIndex = -1;
      results.innerHTML =
        '<p class="search-status">No matches for &ldquo;' + escapeHtml(q) + '&rdquo;.</p>' +
        '<a class="search-viewall" href="/search?q=' + encodeURIComponent(q) + '">Search the whole store &rarr;</a>';
    }

    function search(q) {
      if (q === lastQuery) return;
      lastQuery = q;
      activeIndex = -1;
      results.innerHTML = '<p class="search-status">Searching&hellip;</p>';

      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) {
          if (!r.ok) throw new Error('search failed');
          return r.json();
        })
        .then(function (data) {
          if (input.value.trim() !== q) return; /* a newer query already won */
          var res = (data && data.resources && data.resources.results) || {};
          render(q, res.products || [], res.collections || [], res.pages || []);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          /* Predictive search unavailable — still let them reach /search. */
          results.innerHTML =
            '<a class="search-viewall" href="/search?q=' + encodeURIComponent(q) + '">' +
            'Search for &ldquo;' + escapeHtml(q) + '&rdquo; &rarr;</a>';
        });
    }

    function render(q, products, collections, pages) {
      activeIndex = -1;

      if (!products.length && !collections.length && !pages.length) {
        renderEmpty(q);
        return;
      }

      var html = '';

      if (products.length) {
        html += '<p class="search-section-label">Products</p>';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          var meta = p.available === false
            ? '<span class="is-sold-out">Sold out</span>'
            : money(p.price);
          html +=
            '<a class="search-result" href="' + escapeHtml(p.url) + '">' +
              '<span class="search-result__img">' +
                (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="48" height="48">' : '') +
              '</span>' +
              '<span class="search-result__body">' +
                '<span class="search-result__title">' + escapeHtml(p.title) + '</span>' +
                '<span class="search-result__meta">' + meta + '</span>' +
              '</span>' +
            '</a>';
        });
      }

      if (collections.length) {
        html += '<p class="search-section-label">Collections</p>';
        collections.forEach(function (c) {
          html +=
            '<a class="search-result" href="' + escapeHtml(c.url) + '">' +
              '<span class="search-result__body">' +
                '<span class="search-result__title">' + escapeHtml(c.title) + '</span>' +
              '</span>' +
            '</a>';
        });
      }

      if (pages.length) {
        html += '<p class="search-section-label">Pages</p>';
        pages.forEach(function (pg) {
          html +=
            '<a class="search-result" href="' + escapeHtml(pg.url) + '">' +
              '<span class="search-result__body">' +
                '<span class="search-result__title">' + escapeHtml(pg.title) + '</span>' +
              '</span>' +
            '</a>';
        });
      }

      html += '<a class="search-viewall" href="/search?q=' + encodeURIComponent(q) + '">View all results &rarr;</a>';
      results.innerHTML = html;
    }

    renderIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
